
// src/web/components/user-logout-panel.jsx

import React from 'react'
import connect from '../../connects/user-logout-panel'
import {
  Card,
  CardText,
  CardTitle,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button
} from 'react-toolbox/lib/button'
import Checkbox from 'react-toolbox/lib/checkbox'
import theme from './themes/flat-card.css'

class UserLogoutPanel extends React.Component {
  onCheck = ()=> this.props.updateUI({ allLogout: !this.props.ui.allLogout })

  render() {
    const {
      t,
      ui,
      updateUI,
      logout,
    } = this.props

    return (
      <Card theme={theme}>
        <CardText>
        <Checkbox 
          theme={theme}
          className='logoutCheck'
          checked={ui.allLogout} 
          onChange={this.onCheck} 
          label={t('label:全ての端末でログアウト')}/>
        </CardText>
        <CardActions>
          <Button raised primary
              onClick={() => logout(ui.allLogout)}
              style={{ width: '80%', margin: 'auto' }}
              label={t('label:ログアウトします')} />
        </CardActions>
      </Card>
    )
  }
}

export const RawUserLogoutPanel = UserLogoutPanel
export default connect(UserLogoutPanel)



// WEBPACK FOOTER //
// ./src/web/components/user-logout-panel.jsx